import React from "react";
import {Link} from "react-router-dom";
import {Translate} from "react-localize-redux";
import {Nullable} from "@data-force/app";
import {RightOutlined} from "@ant-design/icons";
import {useSelector} from "react-redux";
import HistoryParams from "../../interfaces/historyParams";
import {getHistoryParams} from "../../utils/common";
import {RoutesMap} from "../../interfaces/common";
import {Routes} from "../../utils/constants";
import StoreState from "../../interfaces/store/storeState";
import "./MoreView.scss";

const MoreView: React.FC = (): React.ReactElement => {
    const translatePath: string = "pages.MoreView.MoreView";
    const facebookLink: string = useSelector(({serviceProperties}: StoreState) => serviceProperties.facebookLink);
    const tikTokLink: string = useSelector(({serviceProperties}: StoreState) => serviceProperties.tikTokLink);
    const instagramLink: string = useSelector(({serviceProperties}: StoreState) => serviceProperties.instagramLink);
    const linkedInLink: string = useSelector(({serviceProperties}: StoreState) => serviceProperties.linkedInLink);
    const youtubeLink: string = useSelector(({serviceProperties}: StoreState) => serviceProperties.youtubeLink);
    const historyParams: Nullable<HistoryParams> = getHistoryParams();
    const {FAQ, SUPPORT}: RoutesMap = Routes;

    return (
        <div className="df-more-container">
            <h3><Translate id={`${translatePath}.help.text`}/></h3>
            <ul>
                {[FAQ, SUPPORT].map((route: string, index: number): React.ReactElement<HTMLLinkElement> => (
                    <li key={`${route}-${index}`}>
                        <Link to={`/${historyParams?.idpId}/${route}`} replace>
                            <Translate id={`${translatePath}.${route}.text`}/>
                            <RightOutlined/>
                        </Link>
                    </li>
                ))}
            </ul>
            <h3><Translate id={`${translatePath}.other.text`}/></h3>
            <a href={facebookLink} target="_blank" rel="noopener noreferrer">
                <Translate id={`${translatePath}.facebookPage.text`}/>
            </a>
            <a href={tikTokLink} target="_blank" rel="noopener noreferrer">
                <Translate id={`${translatePath}.tikTokPage.text`}/>
            </a>
            <a href={instagramLink} target="_blank" rel="noopener noreferrer">
                <Translate id={`${translatePath}.instagramPage.text`}/>
            </a>
            <a href={linkedInLink} target="_blank" rel="noopener noreferrer">
                <Translate id={`${translatePath}.linkedInPage.text`}/>
            </a>
            <a href={youtubeLink} target="_blank" rel="noopener noreferrer">
                <Translate id={`${translatePath}.youtubePage.text`}/>
            </a>
        </div>
    );
};

export default MoreView;
